// src/utils/pageLogDedupe.js
//
// Module-level dedupe for page logging.
//
// Two things caused duplicate writes:
//
//   1. React 18 StrictMode double-invokes effects in development. A ref
//      inside a component doesn't help — the component is remounted, so the
//      ref is fresh. The guard has to live outside React entirely.
//
//   2. Effects re-fire on unrelated re-renders (an auth snapshot landing, a
//      profile field changing), and the same page gets logged again seconds
//      apart.
//
// A short window is the right shape here: the same person reloading the same
// page ten minutes later IS a new visit worth recording, but four writes in
// one second is not.

const WINDOW_MS = 30_000;

const recent = new Map(); // key -> timestamp

export function shouldLog(key) {
  const now = Date.now();

  // Opportunistic cleanup, so the map can't grow without bound in a long
  // session. Cheap: this runs once per page view, not per render.
  for (const [existingKey, at] of recent) {
    if (now - at > WINDOW_MS) recent.delete(existingKey);
  }

  const last = recent.get(key);
  if (last && now - last < WINDOW_MS) return false;

  recent.set(key, now);
  return true;
}
